export default __webpack_public_path__ + "static/media/B136.22539982.png";